import Deletable from './Deletable';
import Expandable from './Expandable';
import Favorite from './Favorite';

export default {Deletable, Expandable, Favorite};



// WEBPACK FOOTER //
// ./src/renderers/index.js